import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.SubmittedPage', {
    pageTitle: 'Wallets - Onboarding | {companyName} | Submitted',
    title: 'Your application has been successfully submitted',
    weReceivedInfo: 'We’ve received your information and our team is reviewing your application details.',
    processTakes: `This process typically takes 1 day to ensure all data is properly verified.
        {submitter} will receive an email update as soon as the review is complete. Additionally you can check
        the status of your application here. We’ll notify you if any additional documents are needed or when your account is approved.`,
    submittedBy: 'Submitted by {submitter} on {submittedAt}',
});
